import { z } from 'zod'

import { DateZod } from '../../common/date-zod'
import { TeamStatusZod } from '../team-zod'

export const MessageZod = z.object({
  sender: z.enum(['volunteer', 'admin']),
  senderId: z.string(),
  volunteerRole: z.enum(['partner', 'escort', 'driver']).optional(),
  senderName: z.string().optional(),
  text: z.string().optional(),
  firebaseStoragePath: z.string().optional(),
  imageProperties: z
    .object({
      width: z.number(),
      height: z.number(),
    })
    .optional(),
  audioStoragePath: z.string().optional(),
  audioDurationMs: z.number().int().positive().optional(),
  teamStatus: TeamStatusZod.optional(),
  transportRequestStatus: z.enum(['allocated', 'assigned', 'on_board']).optional(),
  transportRequestId: z.string().optional(),
  createdAt: DateZod,
  readAt: DateZod.optional(),
  isBroadcast: z.boolean().optional(),
})
